/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/374-rtl': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4 0a4 4 0 000 8v8h2V2h2v14h2V2h2V0H4zm12 3l-4 4 4 4z"/>'
  }
})
